import {RecipeIngredientData} from "../components/cooking/ingredient/recipe-ingredients-edit";
import {RecipeToolData} from "../components/cooking/tool/recipe-tools-edit";

export function compareComparable<T>(items: T[], comparedBy: T[], key: string, comparableKeys: string[]): {
    newItems: T[],
    updatedItems: T[],
    deletedItems: T[]
} {
    let newItems: T[] = [],
        updatedItems: T[] = [],
        deletedItems: T[] = [];

    let foundOld: number[] = [];

    for (let i = 0; i < comparedBy.length; i++) {
        let item = comparedBy[i],
            oldItem = items.find((oldItem, i) => {
                // @ts-ignore
                if(oldItem[key] === item[key]) {
                    foundOld.push(i);
                    return true;
                }
            });

        if (!oldItem) {
            newItems.push(item);
        } else {
            let updated = false;
            for (let key of comparableKeys) {
                // @ts-ignore
                console.log(key, oldItem[key], item[key]);

                // @ts-ignore
                if (oldItem[key] !== item[key]) {
                    updated = true;
                    break;
                }
            }

            if (updated) {
                updatedItems.push(item);
            }
        }
    }

    for (let i = 0; i < items.length; i++) {
        if(!foundOld.includes(i)) {
            deletedItems.push(items[i] as T);
        }
    }

    return {newItems, updatedItems, deletedItems};
}

export class RecipeArray extends Array<Recipe> {
    compareWith: (current: Recipe[]) => {
        newItems: Recipe[];
        updatedItems: Recipe[];
        deletedItems: Recipe[]
    } = (current) => {
        return compareComparable(this, current,
            "publicId",
            ["name", "description",
                "steps", "tips",
                "cuisineTypeId",
                "estimatedPreparationTime", "estimatedCookingTime",
                "servings",
                "rating", "deliciousness", "difficulty"]);
    }
}

export class RecipeIngredientDataArray extends Array<RecipeIngredientData> {
    constructor(recipeIngredientData: RecipeIngredientData[] = []) {
        super(...recipeIngredientData);
    }

    compareWith: (newItems: RecipeIngredientData[]) => {
        newItems: RecipeIngredientData[];
        updatedItems: RecipeIngredientData[];
        deletedItems: RecipeIngredientData[]
    } = (newItems) => {
        return compareComparable(this, newItems, "ingredientId",
            ["amount", "unit"]);
    }
}

export class RecipeToolArray extends Array<RecipeTool> {
    constructor(recipeTools: RecipeTool[] = []) {
        super(...recipeTools);
    }

    compareWith: (current: RecipeTool[]) => {
        newItems: RecipeTool[];
        updatedItems: RecipeTool[];
        deletedItems: RecipeTool[]
    } = (current) => {
        return compareComparable(this, current, "publicId",
            []);
    }
}

export class RecipeToolDataArray extends Array<RecipeToolData> {
    constructor(recipeToolData: RecipeToolData[] = []) {
        super(...recipeToolData);
    }

    compareWith: (newItems: RecipeToolData[]) => {
        newItems: RecipeToolData[];
        updatedItems: RecipeToolData[];
        deletedItems: RecipeToolData[]
    } = (newItems) => {
        return compareComparable(this, newItems, "toolId",
            ["amount", "unit"]);
    }
}